import { Box, ButtonBase, FormControl, MenuItem, TextField, Button as MuiButton } from "@material-ui/core";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Modal } from "vqp-common";
import { Footer, FormContainer, FormLabelControl, FormlLabelPartial, FormPartialDiv, IOSSwitch, Wrapper } from "../style";
import { LogisticsIntegrationTable } from "./LogisticsIntegrationTable";


export const Button = styled(ButtonBase)`
    background-color:${props => props.theme.colors.primary} !important;
    border-radius: 8px !important;
    padding: 6px !important;
    color: white !important;
    &.Mui-disabled {
        opacity: 0.5 !important;
    }
`

const selectPlatform = [
    {
        label: 'Lalamove',
        value: 2
    },
    {
        label: 'BoxDelivery',
        value: 3
    },
    {
        label: 'ClickEntregas',
        value: 5
    },
    {
        label: 'Mottu',
        value: 6
    },
    {
        label: 'Uber',
        value: 7
    },
    {
        label: 'FoodyDelivery',
        value: 8
    },
    {
        label: 'IFood',
        value: 9
    },
]

export const LogisticsIntegration = (props) => {

    const { formik, deliveryPlatform, onChangePlatformPriority, onAddLogistialIntegration, onEditLogisticsIntegration } = props;

    const [openEditModal, setOpenEditModal] = useState({ opened: false, item: undefined });
    const [deleteModal, setDeleteModal] = useState({ opened: false, item: undefined })

    const editForm = useFormik({
        initialValues: {
            platform: 'default$',
            integrationKey: '',
            deliveryTaxCalc: false,
            callDeliveryman: false,
            security: false,
            callDeliverymanManually: true,
            priority: 0,
        }
    })

    const onEdit = () => {
        const newArray = deliveryPlatform.map((value, index) => {
            if (index === openEditModal.item.index) {
                return {
                    platform: editForm.values.platform,
                    integrationKey: editForm.values.integrationKey,
                    deliveryTaxCalc: editForm.values.deliveryTaxCalc,
                    callDeliveryman: editForm.values.callDeliveryman,
                    security: editForm.values.security,
                    callDeliverymanManually: editForm.values.callDeliverymanManually,
                    priority: openEditModal.item.index + 1
                }
            }
            return value;
        })
        onEditLogisticsIntegration(newArray);
        setOpenEditModal({ open: false, item: undefined })
        editForm.resetForm();
    }

    const onDelete = (index) => {
        const newArray = deliveryPlatform.filter((value, vIndex) => index !== vIndex);
        onEditLogisticsIntegration(newArray);
        setDeleteModal({ open: false, index: undefined })
    }


    useEffect(() => {
        if (!openEditModal.opened) return;
        if (!openEditModal.item) return;

        const foundPlatform = selectPlatform.find(
            (platform) => platform.value === openEditModal.item?.platform
        );

        editForm.setValues({
            ...openEditModal.item,
            platform: foundPlatform?.value,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openEditModal.opened, openEditModal.item?.platform])

    return (
        <>
            <FormContainer>
                <FormPartialDiv width={275}>
                    <FormlLabelPartial marginRight="32px">Plataforma:</FormlLabelPartial>
                    <TextField
                        required
                        variant="outlined"
                        size="small"
                        type="number"
                        fullWidth
                        select
                        {...formik.getFieldProps("platform")}
                    >
                        <MenuItem value="default$" disabled>Selecione a plataforma</MenuItem>
                        {
                            selectPlatform.map((item, index) => (
                                <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                            ))
                        }
                    </TextField>
                </FormPartialDiv>
                <FormPartialDiv>
                    <FormlLabelPartial style={{ marginRight: '6px !important' }}>Chave de integração:</FormlLabelPartial>
                    <TextField
                        style={{ width: 300, marginBottom: 3 }}
                        required
                        variant="outlined"
                        placeholder="Digite a chave de integração"
                        size="small"
                        {...formik.getFieldProps("integrationKey")}
                    />
                </FormPartialDiv>
            </FormContainer>
            <FormContainer>
                <FormControl>
                    <FormLabelControl
                        width="100%"
                        style={{ marginLeft: 8 }}
                        control={<IOSSwitch sx={{ m: 1 }} />}
                        checked={formik.getFieldProps("deliveryTaxCalc").value}
                        label="Calcular taxa de entrega"
                        {...formik.getFieldProps("deliveryTaxCalc")}
                    />
                </FormControl>
                <FormControl>
                    <FormLabelControl
                        width="100%"
                        style={{ marginLeft: 8 }}
                        control={<IOSSwitch sx={{ m: 1 }} />}
                        checked={formik.getFieldProps("callDeliveryman").value}
                        label="Chamar entregador"
                        {...formik.getFieldProps("callDeliveryman")}
                    />
                </FormControl>
                <FormControl>
                    <FormLabelControl
                        width="100%"
                        style={{ marginLeft: 8 }}
                        control={<IOSSwitch sx={{ m: 1 }} />}
                        checked={formik.getFieldProps("security").value}
                        label="Seguro"
                        {...formik.getFieldProps("security")}
                    />
                </FormControl>
            </FormContainer>
            <FormContainer removeMarginBottom>
                <FormControl>
                    <FormLabelControl
                        width="100%"
                        style={{ marginLeft: 8 }}
                        control={<IOSSwitch sx={{ m: 1 }} />}
                        checked={formik.getFieldProps("callDeliverymanManually").value}
                        label="Chamar entregador manualmente"
                        {...formik.getFieldProps("callDeliverymanManually")}
                    />
                </FormControl>
            </FormContainer>
            <Box display="flex" alignItems="center" justifyContent="center" mb="12px">
                <Button className="primary" style={{ width: '125px' }}
                    onClick={() => {
                        if (formik.values.platform !== '$default' && formik.values.integrationKey !== undefined && formik.values.integrationKey !== '') {
                            onAddLogistialIntegration({
                                platform: formik.values.platform,
                                integrationKey: formik.values.integrationKey,
                                deliveryTaxCalc: formik.values.deliveryTaxCalc,
                                callDeliveryman: formik.values.callDeliveryman,
                                security: formik.values.security,
                                callDeliverymanManually: formik.values.callDeliverymanManually,
                                priority: deliveryPlatform.length + 1
                            });
                            formik.setValues({
                                ...formik.values,
                                platform: 'default$',
                                integrationKey: '',
                                deliveryTaxCalc: false,
                                callDeliveryman: false,
                                security: false,
                                callDeliverymanManually: false,
                            })
                        }
                    }}
                >
                    Adicionar
                </Button>
            </Box>

            <LogisticsIntegrationTable
                deliveryPlatform={deliveryPlatform}
                selectPlatform={selectPlatform}
                onEdit={(item) => {
                    setOpenEditModal({ opened: true, item: { ...item, index: deliveryPlatform.findIndex((val) => val.platform === item.platform) } })
                }}
                onDelete={(item) => {
                    setDeleteModal({ opened: true, item: { ...item, index: deliveryPlatform.findIndex((val) => val.platform === item.platform) } })
                }}
                onChangePlatformPriority={onChangePlatformPriority}
            />

            <Modal
                isOpen={openEditModal.opened}
                onClose={() => setOpenEditModal({ opened: false, item: undefined })}
                boxWidth="700px"
            >
                <Box p={3}>
                    <FormContainer>
                        <FormPartialDiv width={275}>
                            <FormlLabelPartial marginRight="32px">Plataforma:</FormlLabelPartial>
                            <TextField
                                required
                                variant="outlined"
                                size="small"
                                type="number"
                                fullWidth
                                select
                                {...editForm.getFieldProps("platform")}
                            >
                                <MenuItem value="default$" disabled>Selecione a plataforma</MenuItem>
                                {
                                    selectPlatform.map((item, index) => (
                                        <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                    ))
                                }
                            </TextField>
                        </FormPartialDiv>
                        <FormPartialDiv>
                            <FormlLabelPartial style={{ marginRight: '6px !important' }}>Chave de integração:</FormlLabelPartial>
                            <TextField
                                style={{ width: 300, marginBottom: 3 }}
                                required
                                variant="outlined"
                                placeholder="Digite a chave de integração"
                                size="small"
                                {...editForm.getFieldProps("integrationKey")}
                            />
                        </FormPartialDiv>
                    </FormContainer>
                    <FormContainer>
                        <FormControl>
                            <FormLabelControl
                                width="100%"
                                style={{ marginLeft: 8 }}
                                control={<IOSSwitch sx={{ m: 1 }} />}
                                checked={editForm.getFieldProps("deliveryTaxCalc").value}
                                label="Calcular taxa de entrega"
                                {...editForm.getFieldProps("deliveryTaxCalc")}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabelControl
                                width="100%"
                                style={{ marginLeft: 8 }}
                                control={<IOSSwitch sx={{ m: 1 }} />}
                                checked={editForm.getFieldProps("callDeliveryman").value}
                                label="Chamar entregador"
                                {...editForm.getFieldProps("callDeliveryman")}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabelControl
                                width="100%"
                                style={{ marginLeft: 8 }}
                                control={<IOSSwitch sx={{ m: 1 }} />}
                                checked={editForm.getFieldProps("security").value}
                                label="Seguro"
                                {...editForm.getFieldProps("security")}
                            />
                        </FormControl>
                    </FormContainer>
                    <FormContainer removeMarginBottom>
                        <FormControl>
                            <FormLabelControl
                                width="100%"
                                style={{ marginLeft: 8 }}
                                control={<IOSSwitch sx={{ m: 1 }} />}
                                checked={editForm.getFieldProps("callDeliverymanManually").value}
                                label="Chamar entregador manualmente"
                                {...editForm.getFieldProps("callDeliverymanManually")}
                            />
                        </FormControl>
                    </FormContainer>
                    <Box display="flex" alignItems="center" justifyContent="center" mb="12px">
                        <Button className="primary" style={{ width: '50%' }}
                            onClick={() => {
                                if (editForm.values.platform !== '$default' && editForm.values.integrationKey !== undefined && editForm.values.integrationKey !== '') {
                                    onEdit();
                                }
                            }}>
                            Editar
                        </Button>
                    </Box>
                </Box>
            </Modal>


            {
                !!deleteModal.opened && (
                    <Modal isOpen={!!deleteModal.opened} onClose={() => setDeleteModal({ opened: false, item: undefined })} boxWidth={"450px"}>
                        <Wrapper>
                            Tem certeza que deseja excluir?
                            <Footer>
                                <MuiButton onClick={() => setDeleteModal({ opened: false, item: undefined })}>
                                    Cancelar
                                </MuiButton>
                                <MuiButton color="secondary" onClick={() => onDelete(deleteModal.item.index)}>
                                    Excluir
                                </MuiButton>
                            </Footer>
                        </Wrapper>
                    </Modal>
                )
            }
        </>
    )
}
